import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { ListDTO, ListResponseAPI } from 'src/lib/queries';
import { FinancialDocumentRow } from 'src/features/financialDocumentRows/utils/types';

const RESOURCE = '/financial-documents/financial-document-row/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    financial_document?: string;
}

const queryFn = ({ ...params }: DTO): Promise<ListResponseAPI<FinancialDocumentRow>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_FINANCIAL_DOCUMENT_ROWS_RESOURCE, useQueryHook as useListFinancialDocumentRows };
